import React from 'react';
import { useSelector } from "react-redux";
import Pie from '../../containers/Charts/PieChart';
import {Typography} from 'antd';
import { getRandomColor } from '../../../helper';
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar';
import './StockPortfolio.css';
import 'react-circular-progressbar/dist/styles.css';
import millify from 'millify';
import Error_Optimal from '../../../assets/Error_Optimal.svg';

const Optimal = ({optimal}) => {
    const user_portfolio = useSelector(state => state.portfolio.portfolio_list)
    const labels = user_portfolio?.map((item) => item.symbol);
    const backgroundColors = optimal?.solution?.map(() => getRandomColor());
    const data = {
        labels: labels,
        datasets: [{
            label: "Asset Allocation",
            backgroundColor:['#f1c40f', '#e67e22', '#16a085'].concat(backgroundColors),
            data: optimal.solution,
            labels: {
                render: "true"
            },
        }],
    };
    
    const options = {
        plugins: {
          datalabels: {
            display: true,
            align: 'center',
            borderRadius: 3,
            color: "black",
            font: {
              size: 11,
              weight: 'bold',
            },
            formatter: (val, ctx) => {
                return `${ctx.chart.data.labels[ctx.dataIndex]}\n${millify(val && (val)*100)} %`
              },
          }
        }
      }

    return (
        <div className="w-100 text-center">
            {
                optimal?.solution?.length > 0 && labels?.length > 0 
                ? <div className="w-100 mx-auto">
                    <Typography.Title level={3} className="my-5 text-center">
                        The Most Optimal Portfolio Allocation
                    </Typography.Title>
                    <div className="w-50 mx-auto">
                        <Pie data={data} options={options} className="w-100"/>
                    </div>
                    <br/>
                    <hr/>
                    <div className="w-100 d-flex justify-content-around my-5">
                        <div className="w-25 d-flex flex-column">
                            <Typography.Title level={3} className="my-5 text-center">
                                Portfolio 1 Year Return
                            </Typography.Title>
                            <CircularProgressbar value={millify(optimal?.pm && (optimal?.pm)*250*100)} text={`${millify(optimal?.pm && (optimal?.pm)*250*100)}%`} />
                            <p className="optimal-return-content my-5">
                                This Portfolio is expected to give the return value of {millify(optimal?.pm && (optimal?.pm)*250*100)} % on a year basis under the assumption that market
                                will remain stable regardless of the unprecedented events.
                            </p>
                        </div>
                        <div className="w-25 d-flex flex-column justify-content-start">
                            <Typography.Title level={3} className="my-5 text-center">
                                Portfolio Risk
                            </Typography.Title>
                            <CircularProgressbar
                                value={millify(optimal?.ps && (optimal?.ps)*Math.sqrt(250)*100)}
                                text={`${millify(optimal?.ps && (optimal?.ps)*Math.sqrt(250)*100)}%`}
                                styles={buildStyles({
                                        pathColor: "#dc3545",
                                })}
                            />
                             <p className="optimal-return-content my-5">
                                This Portfolio deviates from its mean value by {`${millify(optimal?.ps && (optimal?.ps)*Math.sqrt(250)*100)}%`}. Volatile nature of the portfolio indicates its risk factor.
                            </p>
                        </div>
                    </div>
                 </div>
                : (
                    <div className="error-optimal my-5">
                        <div className="w-75 h-25 mx-auto my-5">
                            <img src={Error_Optimal} alt="error-optimal" height="400rem"/>
                        </div>
                        <h5 className="text-center my-5">
                            There must be at least three stocks for portfolio optimization
                        </h5>
                    </div>
                )
            }
        </div>
    )
}

export default Optimal
